import { useLayoutEffect, useRef } from 'react';
import { useProfile } from "@contexts/ProfileContext";
import { ZendeskUtils } from "@utils/zendeskUtils.ts";

const srcCN = "https://static.zdassets.com/ekr/snippet.js?key=c020c36f-f7ae-476b-b05b-300d491baddd";
const srcTR = "https://static.zdassets.com/ekr/snippet.js?key=641fa8ae-5707-4c90-8457-cd81d7e9b561";

const ZendeskWidget = () => {
    const scriptRef = useRef<HTMLScriptElement>();
    const { account } = useProfile();

    const addScript = (src: string) => {
      scriptRef.current = document.createElement('script');
      scriptRef.current.src = src;
      scriptRef.current.id = 'ze-snippet';
      scriptRef.current.async = true;
      scriptRef.current.onload = () => {
        if (typeof window.zE === 'function') {
          ZendeskUtils.login();
        } else {
          if (scriptRef.current instanceof HTMLScriptElement) {
            scriptRef.current.remove();
          }
        }
      };
      scriptRef.current.onerror = () => {
        if (scriptRef.current instanceof HTMLScriptElement) {
          scriptRef.current.remove();
        }
      };
      document.body.appendChild(scriptRef.current);
    }

    useLayoutEffect(() => {
      if (account?.region) {
        const src = account?.region === "TR" ? srcTR : srcCN;
        if (scriptRef.current && (src !== scriptRef.current?.src)) {
          ZendeskUtils.logout();
          scriptRef.current.remove();
          addScript(src);
        } else if (!scriptRef.current && account?.region) {
          addScript(src);
        }
      }
    }, [account?.region]);

    return null;
};

export default ZendeskWidget;
